import styled from "styled-components";
import { colorWhite } from "@nib-components/theme";
import { breakpoint } from "@nib/layout";
import { mixins, variables } from "@nib-group/chatbot-shared/styles";
import CONFIG from "./IFrameChatWindow.config";
export const Wrapper = styled.div`
  box-shadow: ${variables.BOX_SHADOW};
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  /* Note it is necessary to have width and height
	on separate elements to include the Toolbar etc */
  width: ${CONFIG.SIZE.MOBILE_WIDTH};

  ${breakpoint("md")`
		width: ${CONFIG.SIZE.TABLET_WIDTH};
	`}

  ${breakpoint("xl")`
		width: ${CONFIG.SIZE.DESKTOP_WIDTH};
	`}
`;
export const IFrameContainer = styled.div`
  position: relative;
  display: flex;
  background: ${colorWhite};

  /* Note it is necessary to have width and height
	on separate elements to include the Toolbar etc */
  height: ${CONFIG.SIZE.MOBILE_HEIGHT};
  max-height: ${CONFIG.SIZE.DESKTOP_HEIGHT};

  ${breakpoint("md")`
		height: ${CONFIG.SIZE.TABLET_HEIGHT};
	`}

  ${breakpoint("xl")`
		height: ${CONFIG.SIZE.DESKTOP_HEIGHT};
	`};
`;
export const Iframe = styled.iframe`
  border: none;
  ${mixins.square("100%")}
`;